import postCancelSellout from '@data/auditTrail/postCancelSellout';
import { useMainState } from '@pages/AuditTrailSellOut/state/state';
import { useSnackbarNotification } from '@store/snackbarNotification';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const usePostCancelSellout = (id) => {
    const queryClient = useQueryClient();

    const { onChangeSnackbarNotification } = useSnackbarNotification();
    const { onChangeMainState } = useMainState();

    return useMutation({
        mutationFn: () => postCancelSellout(id),
        onSuccess: async () => {
            onChangeSnackbarNotification({
                status: 'success',
                title: 'Sedang melakukan cancel sellout.',
                description: '',
                duration: 3,
            });
            queryClient.invalidateQueries(['audit-trail']);

            onChangeMainState({ selectedAuditTrail: {}, isOpenDetailModal: false });
        },
        onError: (error) => {
            const errorMessage = error?.response?.data?.message ?? 'Terdapat sebuah kesalahan sistem';
            onChangeSnackbarNotification({
                status: 'error',
                title: 'Gagal melakukan sync.',
                description: errorMessage,
                duration: 3,
            });
        },
    });
};

export default usePostCancelSellout;
